export default "__VITE_ASSET__DuzrrJJH__"